import { render, staticRenderFns } from "./CreateLeadBoardForm.vue?vue&type=template&id=66fc3246&"
import script from "./CreateLeadBoardForm.vue?vue&type=script&lang=js&"
export * from "./CreateLeadBoardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports